var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ring",style:(`--uib-color: ${_vm.color}; --uib-size: ${_vm.size}`),attrs:{"viewBox":"25 25 50 50","stroke-width":"5"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }